import filter from 'transmute/filter';
// @ts-expect-error module not typed
import { getDisplayGlobally } from 'conversations-internal-schema/connected-email-account/operators/connectedEmailAccountGetters';
export const filterNonGlobalConnectedAccounts = accounts => accounts ? filter(getDisplayGlobally, accounts) : accounts;